import React from 'react';
import { Query } from '@apollo/client/react/components';

import CurrentUserQuery from 'buyside/graphql/queries/CurrentUser';

import ActivityFeedPage from 'buyside/components/presentation/ActivityFeedPage/activityFeedPage';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const ActivityFeedPageContainer = () => (
  <Query query={CurrentUserQuery}>
    {({ loading, data }) => {
      if (loading) return <LoadingSpinner type="secondary" size="large" />;
      if (!data || !data.currentUser) return null;
      return <ActivityFeedPage currentUser={data.currentUser} />;
    }}
  </Query>
);

export default ActivityFeedPageContainer;
